import React from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/products/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="product-card group block bg-white border border-[#E5E2DC] hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
    >
      <div className="overflow-hidden aspect-[4/5] bg-[#F4F4F4]">
        <img
          src={product.image_url}
          alt={product.name}
          className="product-card-image w-full h-full object-contain"
          data-testid={`product-image-${product.id}`}
        />
      </div>
      <div className="p-6">
        {product.tag && (
          <span data-testid={`product-tag-${product.id}`} className="text-xs uppercase tracking-widest text-[#bc64aa] mb-2 block">
            {product.tag}
          </span>
        )}
        <h3 data-testid={`product-name-${product.id}`} className="text-xl font-light mb-2 text-[#641b4d]">
          {product.name}
        </h3>
        <p className="text-sm text-[#7a5e75] mb-3 line-clamp-2">{product.description}</p>
        <div className="flex justify-between items-center">
          <span data-testid={`product-price-${product.id}`} className="text-lg font-semibold text-[#641b4d]">
            ₹{product.price.toFixed(2)}
          </span>
          <span className="text-xs uppercase tracking-wider text-[#7a5e75]">{product.size}</span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;